<template>
  <div id="index" style="max-width:600px;margin:0 auto;">
    <v-layout>      
      <v-btn flat small color="primary" :to="{name: 'reviewPostSearchFood'}">
        <v-icon :size="30">keyboard_arrow_left</v-icon>食品選択に戻る
      </v-btn>
      <v-spacer></v-spacer>
      <v-chip flat dark color="primary">カラログを登録</v-chip>
    </v-layout>
    <v-card>
      <v-container>
        <review-form
          @onSendAccept='onSendAccept'
          @onSendFin='onSendFin'          
          @onMessage='onMessage'
          mode='noFood'
        ></review-form>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import ReviewForm from '@/components/form/ReviewForm.vue'
export default {
  name: 'ReviewViewMin',
  data () {
    return {
      postId: ''
    }
  },
  head: {
    title () {
      return {
        inner: 'カラログ投稿',
        separator: ' ',
        complement: 'カライイネ'
      }
    },
    meta () {
      return [
        {name: 'description', content: '激辛口コミサイト「カライイネ」にカラログを投稿しよう'}
      ]
    }
  },
  computed: {
    food () {
      return this.$store.state.temp.foodData
    },
    imageurls () {
      return this.$store.state.temp.images
    }
  },
  created () {
    this.scrollIni()
    if (this.$route.params.mode) {
      this.mode = this.$route.params.mode
      if (this.mode !== 'food') {
        this.$store.commit('deleteTempFoodData')
      }
    }
  },
  methods: {
    onFinSecound () {
      console.log('onFinSecound')
    },
    resetRank () {
      console.log('resetRank')
    },
    onSendAccept (postId) {
      this.postId = postId
    },
    onSendFin () {
      let obj = {
        group: 'messageBottom',
        type: 'success',
        title: 'Thank you!!',
        text: 'カラログを登録しました。'
      }
      this.$emit('onMessage', obj)
      this.$store.commit('initPost')
      this.$router.push({name: 'searchReviewDetail', params: {id: this.postId}})
    },
    scrollIni () {
      window.scrollTo(0, 0)
    },
    onMessage (obj) {
      this.$emit('onMessage', obj)
    }
  },
  head: {
    link () {
      return [
        {rel: 'canonical', href: 'https://karaiine.jp/'}
      ]
    }
  },
  components: {
    ReviewForm
  }
}
</script>

<style scoped>
  #index{
    min-height:90vh;
    text-align:center;
  }
</style>